import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Button,
  IconButton,
  Paper,
  Typography,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import ViewColumnIcon from "@material-ui/icons/ViewColumn";
import SwapHorizIcon from "@material-ui/icons/SwapHoriz";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";

const useStyles = makeStyles((theme) => ({
  bar: {
    position: "absolute",
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 10,
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    padding: theme.spacing(1, 1.5),
    borderTop: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
    flexWrap: "wrap",
  },
  count: {
    flex: 1,
    minWidth: 120,
    fontWeight: 600,
  },
  actionButton: {
    textTransform: "none",
  },
}));

const TicketListBulkActionBar = ({
  selectedCount,
  onClose,
  onTransfer,
  onAddTag,
  onKanban,
  onCloseTickets,
  canTransfer = true,
}) => {
  const classes = useStyles();

  if (!selectedCount) return null;

  return (
    <Paper className={classes.bar} elevation={4} square>
      <IconButton size="small" onClick={onClose} aria-label="Cancelar seleção">
        <CloseIcon fontSize="small" />
      </IconButton>
      <Typography variant="body2" className={classes.count}>
        {selectedCount} selecionado{selectedCount > 1 ? "s" : ""}
      </Typography>
      {canTransfer && (
        <Button
          size="small"
          className={classes.actionButton}
          startIcon={<SwapHorizIcon />}
          onClick={onTransfer}
        >
          Transferir
        </Button>
      )}
      <Button
        size="small"
        className={classes.actionButton}
        startIcon={<LocalOfferIcon />}
        onClick={onAddTag}
      >
        Tag
      </Button>
      <Button
        size="small"
        className={classes.actionButton}
        startIcon={<ViewColumnIcon />}
        onClick={onKanban}
      >
        Kanban
      </Button>
      <Button
        size="small"
        className={classes.actionButton}
        color="secondary"
        startIcon={<HighlightOffIcon />}
        onClick={onCloseTickets}
      >
        Fechar
      </Button>
    </Paper>
  );
};

export default TicketListBulkActionBar;
